import React from 'react';
import jalaali from 'jalaali-js';

const useSetInitialDateForEdit = (
  initialValue,
  setValue
) => {
  React.useEffect(() => {
    if (!initialValue) {
      return;
    }
    const jalaliDate = initialValue.split('/');
    const gregorianDate = jalaali.toGregorian(
      parseInt(jalaliDate[0]),
      parseInt(jalaliDate[1]),
      parseInt(jalaliDate[2])
    );
    const date = new Date(
      gregorianDate.gy,
      gregorianDate.gm - 1,
      gregorianDate.gd
    );
    setValue(date);
  }, [initialValue]);
};

export default useSetInitialDateForEdit;
